import * as THREE from 'three';
import type { EnemyKind } from '../../../core/types';
import type { Theme } from '../../../core/config/theme';

// Translates a theme's material presets into concrete Three.js materials. Glass
// presets become MeshPhysicalMaterial (transmission + clearcoat); everything
// else is MeshStandardMaterial. Centralizing this is what makes the future art
// pass a theme edit rather than a hunt through render code.
export function createEnemyMaterial(
  kind: EnemyKind,
  color: number,
  theme: Theme,
  envMap: THREE.Texture | null,
): THREE.Material {
  const preset = theme.materials[kind];
  if (preset.glass) {
    return new THREE.MeshPhysicalMaterial({
      color,
      metalness: preset.metalness,
      roughness: preset.roughness,
      clearcoat: 0.5,
      clearcoatRoughness: 0.4,
      reflectivity: 0.6,
      transmission: 1 - preset.opacity + 0.7,
      transparent: true,
      opacity: preset.opacity,
      emissive: color,
      emissiveIntensity: preset.emissiveIntensity,
      envMap,
      envMapIntensity: preset.envMapIntensity,
    });
  }
  return new THREE.MeshStandardMaterial({
    color,
    metalness: preset.metalness,
    roughness: preset.roughness,
    // Self-colored glow, theme-tuned: night themes raise emissiveIntensity so
    // enemies stay readable in the dark.
    emissive: color,
    emissiveIntensity: preset.emissiveIntensity,
    envMap,
    envMapIntensity: preset.envMapIntensity,
  });
}
